// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.res.mjs";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Theme$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Theme.res.mjs";

function NoMatch(props) {
  var children = props.children;
  var childrenSlotCss = Theme$LiteracyplanetClientFlags.resizeExtra({
        hd: Css.fontWeight("bold"),
        tl: {
          hd: Css.color({
                NAME: "hex",
                VAL: "FFF"
              }),
          tl: {
            hd: Css.display("flex"),
            tl: {
              hd: Css.justifyContent("center"),
              tl: /* [] */0
            }
          }
        }
      }, undefined, {
        hd: [
          Theme$LiteracyplanetClientFlags.paddingTop,
          50
        ],
        tl: {
          hd: [
            Theme$LiteracyplanetClientFlags.fontSize,
            30
          ],
          tl: /* [] */0
        }
      });
  return React.createElement("div", {
              className: childrenSlotCss
            }, children !== undefined ? Caml_option.valFromOption(children) : "Page not found");
}

var ratioExt = Theme$LiteracyplanetClientFlags.resizeExtra;

var make = NoMatch;

export {
  ratioExt ,
  make ,
}
/* Css Not a pure module */
